"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const E = require("fp-ts/lib/Either");
const ibantools_1 = require("ibantools");
const _1 = require(".");
function ibanV(path, countryCode) {
    return x => {
        const candidate = ibantools_1.extractIBAN(ibantools_1.electronicFormatIBAN(x));
        return candidate.valid && (countryCode == null || candidate.countryCode === countryCode) ? E.right(x) : E.left([
            new _1.ValidationError(path, countryCode != null ? `${x} is invalid ${countryCode} iban` : `${x} is invalid iban`, new InvalidIbanInfo(x, countryCode))
        ]);
    };
}
exports.ibanV = ibanV;
class InvalidIbanInfo {
    constructor(actual, countryCode) {
        this.actual = actual;
        this.countryCode = countryCode;
        this.type = 'invalidIban';
    }
}
